import { Data } from "../types";

import { HeadCell } from "@/components/app/EnhancedTableHeader/type";

const headCells: HeadCell<Data>[] = [
    {
        id: "id",
        numeric: true,
        disablePadding: true,
        label: "ID",
    },
    {
        id: "deviceUid",
        numeric: false,
        disablePadding: true,
        label: "Device UID",
    },
    {
        id: "deviceName",
        numeric: false,
        disablePadding: true,
        label: "Device Name",
    },
    {
        id: "status",
        numeric: false,
        disablePadding: true,
        label: "Status",
    },
    {
        id: "lastSeenAt",
        numeric: false,
        disablePadding: true,
        label: "Last Seen At",
    },
    {
        id: "createdAt",
        numeric: false,
        disablePadding: true,
        label: "Created At",
    },
];

export default headCells;
